import React from 'react';

import { isAiSearchOn } from '@helpers/semantic_search';
import ShowPage from '@components/show_page/sections/show-page';

const SearchPage = (props) => {
  if (typeof window !== 'undefined' && !isAiSearchOn()) {
    window.location.replace(window.location.pathname);
    return null;
  }

  return (
    <ShowPage
      {...props}
      searchPageMode
      sectionDropdownSetting={false}
    />
  );
};

export default SearchPage;
